import { useTranslation } from "react-i18next";
import { ArrowUpRightIcon, ArrowDownRightIcon } from "@phosphor-icons/react";

import { formatPercentage } from "@shared/helpers";

import {
  BRAND_LABEL_KEY,
  CAPTURE_LABEL_KEY,
  VALUE_COLUMN_LABEL_KEY_BY_VERSION,
} from "./installments-table.constants";

import styles from "./installments-table.module.css";

import type { InstallmentsTableProps } from "./installments-table.type";

export const InstallmentsTable = ({
  installments,
  taxAggregateVersion = "2",
}: InstallmentsTableProps) => {
  const { t } = useTranslation();

  if (installments.length === 0) return null;

  const valueColumnLabelKey =
    VALUE_COLUMN_LABEL_KEY_BY_VERSION[taxAggregateVersion];

  return (
    <div className={styles.section}>
      <div className={styles["table-wrapper"]}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>
                {t("payfac.pageRatePlanHistoryModalInstallmentsColumnParc")}
              </th>
              <th className={styles["th-right"]}>
                {t(valueColumnLabelKey)}
              </th>
            </tr>
          </thead>
          <tbody>
            {installments.map((diff) => {
              const captureLabel = t(
                CAPTURE_LABEL_KEY[diff.capture] ?? diff.capture,
              );
              const brandLabel = t(BRAND_LABEL_KEY[diff.brand] ?? diff.brand);
              const isIncrease = diff.newValue > diff.oldValue;
              const isDecrease = diff.newValue < diff.oldValue;

              return (
                <tr key={`${diff.capture}-${diff.brand}-${diff.installment}`}>
                  <td className={styles["parc-cell"]}>
                    {diff.installment}x
                    <span className={styles["row-meta"]}>
                      · {captureLabel} · {brandLabel}
                    </span>
                  </td>
                  <td className={styles["value-cell"]}>
                    <span className={styles["value-inner"]}>
                      <span className={styles.old}>
                        {formatPercentage(diff.oldValue)}
                      </span>
                      {isIncrease && (
                        <ArrowUpRightIcon
                          size={14}
                          weight="bold"
                          className={styles["arrow-up"]}
                        />
                      )}
                      {isDecrease && (
                        <ArrowDownRightIcon
                          size={14}
                          weight="bold"
                          className={styles["arrow-down"]}
                        />
                      )}
                      <span className={styles.new}>
                        {formatPercentage(diff.newValue)}
                      </span>
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
